import { render } from "./list-items.vue?vue&type=template&id=1de50f09&scoped=true"
import script from "./list-items.vue?vue&type=script&lang=js"
export * from "./list-items.vue?vue&type=script&lang=js"

import "./list-items.vue?vue&type=style&index=0&id=1de50f09&lang=stylus&scoped=true"

import exportComponent from "/var/www/docker/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1de50f09"],['__file',"src/components/admin-dashboard/list/list-items.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1de50f09"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1de50f09', __exports__)) {
    api.reload('1de50f09', __exports__)
  }
  
  module.hot.accept("./list-items.vue?vue&type=template&id=1de50f09&scoped=true", () => {
    api.rerender('1de50f09', render)
  })

}


export default __exports__